import * as R from "ramda";
import React from "react";
import ToggleButton from "react-toggle-button";
import Button from "../../../modules/commons/Button";

export const tableColumns = [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (_, { rowIndex }) => <>{rowIndex + 1}</>,
        },
    },
    {
        name: "roleName",
        label: "Nama Role",
    },
    {
        name: "ahasLine",
        label: "Ahass Line",
        options: {
            customBodyRender: (val) => <p>{val}</p>,
            sort: false,
        },
    },
    {
        name: "mktLine",
        label: "Mkt Line",
        options: {
            customBodyRender: (val) => <p>{val}</p>,
            sort: false,
        },
    },
    {
        name: "adminLine",
        label: "Adm Line",
        options: {
            customBodyRender: (val) => <p>{val}</p>,
            sort: false,
        },
    },
    {
        name: "status",
        label: "Status",
        options: {
            customBodyRender: (_, { rowIndex }) => (
                <ToggleButton
                    value={R.equals(this.state.dataTable[rowIndex].status, "ACTIVE")}
                    onToggle={() => this.handleChangeStatus(rowIndex)}
                />
            ),
            sort: false,
        },
    },
    {
        name: "",
        label: "Action",
        options: {
            customBodyRender: (_, { rowIndex }) => {
                return (
                    <div style={{ width: "115px" }}>
                        <Button
                            className="btnAct"
                            style={{ marginRight: 15, backgroundColor: "transparent" }}
                            onClick={() => this.handleModifyingModalVisibility(rowIndex)}
                        >
                            <i
                                className="fa fa-lw fa-pencil-alt"
                                style={{
                                    backgroundColor: "transparent",
                                    color: "red",
                                    fontSize: 20,
                                }}
                            />
                        </Button>
                        <Button
                            className="btnAct"
                            style={{ marginRight: 15, backgroundColor: "transparent" }}
                            onClick={() => this.handleDelete(rowIndex)}
                        >
                            <i
                                className="fa fa-trash"
                                style={{
                                    backgroundColor: "transparent",
                                    color: "red",
                                    fontSize: 20,
                                }}
                            />
                        </Button>
                    </div>
                );
            },
            sort: false,
        },
    },
];

export const formGroup = {
    roleName: { value: "", mandatory: true },
    ahasLine: { value: "", mandatory: true },
    mktLine: { value: "", mandatory: true },
    adminLine: { value: "", mandatory: true },
    status: { value: "INACTIVE" },
};
